import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const DEFAULT_STYLES: StyleObj = {
  root: {},
  acceptBtn: {
    borderRadius: 0,
    width: '50%',
    color: 'white',
    py: 1.5,
  },
  rejectBtn: {
    borderRadius: 0,
    width: '50%',
    color: 'white',
    py: 1.5,
    backgroundColor: 'error.600',
    ':hover': {
      backgroundColor: 'error.700',
    },
  },
};

const NEOBET_STYLES: StyleObj = {
  root: {
    display: 'flex',
    gap: 1,
  },
  acceptBtn: {
    flex: 1,
    borderRadius: 1.5,
    py: 1,
    fontWeight: 800,
    backgroundColor: 'success.main',
    ':hover': {
      backgroundColor: 'success.dark',
    },
  },
  rejectBtn: {
    flex: 1,
    borderRadius: 1.5,
    py: 1,
    fontWeight: 800,
    backgroundColor: 'error.400',
    ':hover': {
      backgroundColor: 'error.500',
    },
  },
};

export const REOFFERED_BETSLIP_ACTIONS_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: DEFAULT_STYLES,
  [SKIN.GOLA]: DEFAULT_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};
